import { createBasket, updateBasket } from '@store/basket/actions';
import { connect } from 'react-redux';
import { destroy, formValueSelector } from 'redux-form';
import { basketSelectors } from '@store/basket/selectors';
import { SpaPackageModal } from './SpaPackageModal';
import { ExtrasFormDataType, StateProps } from './SpaPackageModal.types';
import { SPA_PACKAGE_FORM_NAME } from './shared';
import moment from 'moment';
import { yourJourneySelectors } from '@store/yourJourney/selectors';

export const calculateExtraPrices = (extras: ExtrasFormDataType): number =>
  Object.values(extras || {})
    .flatMap((extras) => extras?.map((extra) => extra.price))
    .reduce((acc, cur) => (cur?.amount || 0) + acc, 0);

const mapStateToProps = (state): StateProps => ({
  currentBasketItems: basketSelectors.getBasketDetails(state)?.items,
  isFetchingAvailability: basketSelectors.getIsBasketDetailsFetching(state),
  arrivalTime: formValueSelector(SPA_PACKAGE_FORM_NAME)(state, 'arrivalTime'),
  extrasTotal: calculateExtraPrices(formValueSelector(SPA_PACKAGE_FORM_NAME)(state, 'extras')),
  guestsCount: formValueSelector(SPA_PACKAGE_FORM_NAME)(state, 'guests')?.length || 0,
  selectedDate: moment(
    formValueSelector(SPA_PACKAGE_FORM_NAME)(state, 'date') ||
      yourJourneySelectors.getParsedJourneyParams(state).spaDate
  ),
});

const mapDispatchToProps = {
  createBasket,
  updateBasket,
  destroy,
};
export const SpaPackageModalConnected: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpaPackageModal as any);
